import React, { useContext } from 'react'

import { useGetChargebeeModuleId } from 'modules/marketplace_modules/hooks/useGetChargebeeModuleId'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { RequestUpgradeProps } from 'modules/upsell/lib/requestUpgradeTypes'

type Step =
  | 'upsell-step'
  | 'thankyou-request-info-step'
  | 'thankyou-trial-step'
  | 'book-a-meeting-step'

type UpsellModalProviderProps = {
  children: React.ReactNode | React.ReactNode[]
  currentStep: Step
  setStep: (step: Step) => void
  requestDetail: RequestUpgradeProps
  withTrialCta: boolean
}

type UpsellModalContextProps = {
  shouldShowTrialCta: boolean
  currentStep: Step
  setStep: (step: Step) => void
  chargebeeModuleId: string | null | undefined
  requestDetail: RequestUpgradeProps
  loading: boolean
}

const UpsellModalContext = React.createContext<UpsellModalContextProps>({
  chargebeeModuleId: undefined,
  currentStep: 'upsell-step',
  setStep: (_: Step) => {
    return
  },
  requestDetail: {
    requestReason: ValidReasons.UpgradeFromLegacy,
    featureRequested: undefined,
    moduleRequested: undefined,
    requestSource: undefined,
  },
  shouldShowTrialCta: false,
  loading: true,
})
export const UpsellModaContextProvider = ({
  children,
  requestDetail,
  withTrialCta,
  currentStep,
  setStep,
}: UpsellModalProviderProps) => {
  const { id: chargebeeModuleId, loading } = useGetChargebeeModuleId(requestDetail.moduleRequested)

  return (
    <UpsellModalContext.Provider
      value={{
        shouldShowTrialCta: withTrialCta && !!requestDetail.moduleRequested && !!chargebeeModuleId,
        currentStep,
        setStep: setStep,
        chargebeeModuleId,
        requestDetail,
        loading,
      }}
    >
      {children}
    </UpsellModalContext.Provider>
  )
}

export const useUpsellModalContext = () => useContext(UpsellModalContext)
